(function ($, Drupal, drupalSettings) {
  'use strict';

  Drupal.behaviors.photoCollageDefault = {
    scrollParallax: function () {

      // Un-slick any collage collections.
      $('.tnv-photo-collage-wrapper.processed').slick('unslick');

      // Use scroll position to set parallax animation.
      $('.tnv-photo-collage-wrapper').each(function (index) {
        var offsetTop = $(this).offset().top;
        var sectionHeight = $(this).outerHeight();
        var topBounds = offsetTop - window.innerHeight;
        var bottomBounds = offsetTop + sectionHeight;
        var scrollDuration = bottomBounds - topBounds;
        var currentScrollPos = (((window.scrollY - topBounds) / scrollDuration).toFixed(2) * -100) + 50;

        $(this).css('perspective-origin', '100% ' + currentScrollPos + '%');
      });

    },
    slickCollage: function () {

      if ($('.page-node-type-category-page').length === 0) {
        // Enable slick slider on the images.
        $('.tnv-photo-collage-wrapper:not(.processed)').addClass('processed').each(function () {
          $(this).slick({
            useCss: true,
            arrows: true,
            infinite: false,
            variableWidth: true,
            centerMode: true,
            centerPadding: '8px'
          });
          var slideCount = $(this).slick('getSlick').slideCount;
          var slideStart = Math.round(slideCount / 2 - 1);
          $(this).slick('slickGoTo', slideStart);

          $(this).on('afterChange', function (event, slick, currentSlide, nextSlide) {
            document.blazy = new Blazy(); // eslint-disable-line no-undef
            document.blazy.revalidate();
          });
        });
      }

    },
    attach: function () {

      // On resized, modify current collage style.
      $(window).resize(function () {
        if (window.innerWidth >= 1248) {
          Drupal.behaviors.photoCollageDefault.scrollParallax();
        }
        else if ($('.tnv-photo-collage-wrapper:not(.processed)').length) {
          Drupal.behaviors.photoCollageDefault.slickCollage();
        }
      });

      // Monitor scroll position.
      $(window).scroll(function () {
        if (window.innerWidth >= 1248) {
          Drupal.behaviors.photoCollageDefault.scrollParallax();
        }
      });

      // Run resize automatically on page load.
      $(window).resize();

    }
  };

})(jQuery, Drupal, drupalSettings);
